import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Stack} from 'views/components';
import {Tab, TabContext, TabList, TabPanel} from 'views/components';

import {translate} from 'views/module';

import ClientLeadHeader from './header/ClientLeadHeader';
import Correspondances from './correspondances/Correspondances';

const ClientLeadFeed = (props) => {
  const [value, setValue] = React.useState('CORRESPONDANCE');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper >
      <Stack>
        <ClientLeadHeader
          {...props}
        />
        <TabContext
          value={value}
        >
          <TabList
            onChange={handleChange}
            sx={{borderBottom: 1, borderColor: 'divider'}}
          >
            <Tab
              label={translate('clientLead.ClientLeadDetail.Correspondance.Title')}
              value="CORRESPONDANCE"
            />
            <Tab
              label={'SCHEDULING'}
              value="Schedule"
            />
          </TabList>
          <TabPanel
            value={'CORRESPONDANCE'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Correspondances
              {...props}
            />
          </TabPanel>
        </TabContext>
      </Stack>
    </Paper>
  );
};
ClientLeadFeed.propTypes = {
  clientLeadRn: PropTypes.string.isRequired,
  clientLeadData: PropTypes.object.isRequired,
};

export default React.memo(ClientLeadFeed);
